import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Renderer2
} from '@angular/core';
import { WizBaseLayout } from '../../core/wiz-base-layout';

/**
 * Spacer, élément vide à dimension définie
 */
@Component({
  selector: 'wiz-spacer',
  template: '<div><ng-content></ng-content></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WizSpacer extends WizBaseLayout {

  // Facteur de rétrécissement passé à l'élément hôte car le spacer est considéré comme un élément vide
  @HostBinding('style.flex-shrink') flexShrink = 1;

  constructor(elementRef: ElementRef, renderer: Renderer2, cdref: ChangeDetectorRef) {
    super(elementRef, renderer , cdref);
  }
}
